module.exports = require("react-markdown");


//////////////////
// WEBPACK FOOTER
// external "react-markdown"
// module id = 174
// module chunks = 0